import controller from './kform-builder-list.controller';
import template from './kform-builder-list.html';

const kformBuilderListComponent = {
	bindings:    {
		component:       '<',
		form:            '<',
		parent:          '<?',
		hideDndBoxCount: '<',
		rootList:        '<',
		options:         '<',
		data:            '=?',
	},
	controller,
	template,
};

export default kformBuilderListComponent;
